<template>
  <div id="app" class="app-container">
    <router-view  style="position: absolute;left: 0;top: 0;height: 100%;width: 100%;" />
    <HeaderView  class="header"></HeaderView>
    <HeaderView  class="header2"
      :style="{ transform: showHeader2 ? 'translateY(0)' : 'translateY(-100%)' }">
    </HeaderView>
  </div>
</template>

<script>
import HeaderView from '@/components/headerView/index'
export default {
  name: 'App',
  components: {
    HeaderView
  },
  data () {
    return {
      loadingNum: 0,
      loadingAll: 0,
      showHeader2: false
    }
  },
  computed: {
    isLodingFinish () {
      if (this.loadingNum > 0 && this.loadingAll > 0) {
        return this.loadingNum === this.loadingAll
      } else {
        return false
      }
    }
  },
  created () {

  },
  mounted () {
    window.addEventListener('scroll', this.windowScrollListener)
    // 先把首页的图片加载完
    // let arr = [
    //   require('@/assets/banner1.jpg'),
    //   require('@/assets/banner2.jpg'),
    //  require('@/assets/banner3.jpg'),
    //  require('@/assets/banner4.jpg')]
    // this.loadingAll = arr.length
    //  arr.forEach((item) => {
    //   let image = new Image()
    //  image.src = item
    //  image.onload = () => {
    //    this.loadingNum++
    //  }
    //  image.onerror = () => {
    //   this.loadingNum++
    //  }
    // })

    //  let assets = require.context('@/assets', true)
    //  assets.keys().forEach((key, index) => {
    //    let name = key.slice(2, key.length)
    //   if (!arr.some(item => item.indexOf(name) > -1)) {
    //    let image = new Image()
    //   image.src = require(`@/assets/${name}`)
    //  }
    // })
  },

  methods: {
    windowScrollListener () {
      this.showHeader2 = window.scrollY > window.innerHeight
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.windowScrollListener)
  }
}
</script>

<style>
.app-container {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;

}

.header {
  width: 100%;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}

.header2 {
  width: 100%;
  height: 100px;
  position: fixed !important;
  top: 0;
  left: 0;
  transition: all 0.3s;
  z-index: 9999;
  background: linear-gradient(rgba(0, 0, 0, 0.8), transparent) !important;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}

/* 整个滚动条 */
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  /* 滚动条宽度 */
  border-radius: 10px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
  /* 滚动条轨道颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 10px;
  /* 滚动条滑块颜色 */
}

/* 滚动条的滑块：鼠标悬停时 */
::-webkit-scrollbar-thumb:hover {
  background: #999;
  border-radius: 10px;
  /* 滚动条滑块颜色：鼠标悬停时 */
}

.single-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-image-viewer__wrapper {
  z-index: 99999 !important;
}
</style>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/App.vue